import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SeedService } from '@app/core/seed.service';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AlertService } from '@app/core/alert.service';

@Component({
  selector: 'app-fairness-modal',
  template: `
    <div (click)="reject()" class="icon close-popup"><i class="fal fa-times" data-id="fairness-close-button"> </i></div>
    <!-- <div class="general-popup-content"> -->
    <!-- <div class="general-popup-text-wrap"> -->
    <!-- <h5 translate>fairness_popup.headline</h5> -->
    <!-- <p>Choose your seed provider</p> -->

    <h5 translate>fairness_popup.current</h5>
    <div class="_20px-spacer"></div>
    <div class="radio-wrap">
      <form class="radio-inline" [formGroup]="form" novalidate>
        <app-form-radio formControlName="radio" name="radio" data-id="fairness-seed-radio1" value="rndOrg">
          Random.org</app-form-radio
        >
        <app-form-radio formControlName="radio" name="radio" data-id="fairness-seed-radio2" value="moz">
          Mozilla Cripto Lib</app-form-radio
        >
        <app-form-radio formControlName="radio" name="radio" data-id="fairness-seed-radio3" value="own">
          Custom</app-form-radio
        >
      </form>
    </div>
    <app-form-input
      [disabled]="!(form.get('radio').value === 'own')"
      [value]="seedValue"
      [title]="'fairness_popup.client_seed' | translate"
      (change)="seedChanged($event.target)"
      data-id="fairness-clientSeed-input"
    ></app-form-input>

    <app-form-input
      [disabled]="true"
      [value]="getCurrentSeed().hashedServerSeed"
      [title]="'fairness_popup.server_seed_hash' | translate"
      data-id="fairness-serverSeed-readonly"
    ></app-form-input>

    <div class="_20px-spacer"></div>
    <br />
    <br />

    <h5 translate>fairness_popup.previous</h5>

    <app-form-input
      [disabled]="true"
      [value]="getPrevSeed().clSeed"
      data-id="fairness-prevClientSeed-readonly"
      [title]="'fairness_popup.client_seed' | translate"
    ></app-form-input>
    <app-form-input
      [disabled]="true"
      [value]="getPrevSeed().srvSeed"
      data-id="fairness-prevServerSeed-readonly"
      [title]="'fairness_popup.server_seed_plain' | translate"
    ></app-form-input>
    <app-form-input
      [disabled]="true"
      data-id="fairness-prevHashedSeed-readonly"
      [value]="getPrevSeed().hashedServerSeed"
      [title]="'fairness_popup.server_seed_hash' | translate"
    ></app-form-input>
  `,
})
export class FairnessModalComponent implements OnInit {
  seedValue: string = null;
  seedError: string = null;
  form: FormGroup;

  constructor(
    private ref: NgbActiveModal,
    public seed: SeedService,
    private formBuilder: FormBuilder,
    private alertService: AlertService
  ) {}

  ngOnInit() {
    this.form = this.formBuilder.group({
      radio: [this.seed.curSeeds.rndNrMethod, [Validators.required]],
    });
    this.form.get('radio').valueChanges.subscribe((val: string) => {
      this.setSeedType(val);
    });
    this.seedValue = this.seed.curSeeds.clSeed;
  }

  setSeedType(type: string): void {
    this.seed.curSeeds.rndNrMethod = type;
  }

  getCurrentSeed(): any {
    return this.seed.curSeeds;
  }

  getPrevSeed(): any {
    return this.seed.lastSeeds;
  }

  seedChanged($event: any): void {
    this.seedValue = $event.value;
    const hex = this.checkSeed(this.seedValue);
    if (hex === '') {
      this.alertService.error({
        title: 'Error!',
        text: 'Unable to encode your seed to HEX. Max 32bit int or 32byte hex.',
        timer: 15,
      });
    } else {
      this.seed.curSeeds.clSeed = hex;
    }
  }

  public close(): void {
    this.ref.close();
  }

  public reject(): void {
    this.ref.dismiss();
  }

  private checkSeed(newRndNr: any): string {
    if (newRndNr === '' || newRndNr === null) {
      return '';
    }

    if (!isNaN(newRndNr) && newRndNr.length < 10) {
      newRndNr = parseInt(newRndNr, 10).toString(16);
    } else {
      const re = /^[0-9A-Fa-f]*$/g; // ensure client seed is valid hex
      if (!re.test(newRndNr)) {
        return '';
      }
    }
    let pad = '';
    if (newRndNr.length < 64) {
      for (let i = 0; i < 64 - newRndNr.length; i++) {
        pad += '0';
      }
    }
    return '0x' + pad + newRndNr;
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/shared/modals/fairness-modal.component.ts